export default __webpack_public_path__ + "static/media/MACS_logo.211d7c94.svg";